import {sendRequest} from "./APIClient";
import {AxiosResponse} from "axios";

export async function getAppointments(from: string | null = null, to: string | null = null): Promise<AppointmentItem[]> {
  try {
    let url = `/appointments`;

    if (from && to) {
      url += `/reports?from=${from}&to=${to}`;
    } else if (from) {
      url += `?from=${from}`;
    }
    const response = await sendRequest<null, AppointmentItem[]>(url, 'get');
    return response.data.sort((a: AppointmentItem, b: AppointmentItem) => Date.parse(a.startTime) - Date.parse(b.startTime));
  } catch (error) {
    console.error('Error fetching appointments:', error);
    throw error;
  }
}

export async function updateAppointment(
  requestType: string,
  data: AppointmentItem | AppointmentItem[],
  onSuccess?: (response: AxiosResponse) => void,
  onError?: (error: any) => void
): Promise<boolean> {
  if (!data || (Array.isArray(data) && data.length === 0)) {
    console.error('Invalid data passed to updateAppointment');
    return false;
  }

  let requestData;
  if (Array.isArray(data)) {
    requestData = data;
  } else {
    requestData = [data];
  }

  try {
    const response = await sendRequest('/appointments', requestType, requestData)
    if (onSuccess) onSuccess(response);
    return true;
  } catch (error: any) {
    console.error('Error updating appointment', error.response || error);
    if (onError) onError(error);
    return false;
  }
}